angular
    .module('app')
    .component('winbackStateOffersEdit', {
        templateUrl: '/templates/pages/winback-state-offers/winback-state-offers-edit/winback-state-offers-edit.html',
        controller: 'WinbackStateOffersEditController',
        controllerAs: 'vm',
    });